import React from "react";
import {NavLink} from "react-router-dom";
import pageList from './pageList';
import Request, {CODES} from '../../utils/Request';
import {Duplicate} from '../../utils/svgs';

// import GeneralAnimations from '../utils/generalAnimations';
// import {TweenMax, Power2} from "gsap/TweenMax";


class pageListProducts extends pageList {
	
	constructor(props){
		super(props)
		this.apiName = 'products';
		this.listSlug = 'productos';
		this.singleItem = 'producto'; //Name of a single list item
		this.listTitle = 'Productos';

		// this.hasRowOptions = false;
	}
	
	componentDidMount(){
		this.requestPages();
	}

	getTable(pages){
		let table = {};
		table.headers = [
			{
				slug: 'brand',
				name: 'Brand',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'name',
				name: 'Nombre',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku',
				name: 'SKU',
				class: 'item-big',
				canSearch: true,
			},
			{
				slug: 'sku_soultek',
				name: 'SKU Soultek',
				class: 'item-big',
				canSearch: true,
				canSort: true,
				sortType: 'string',
			},
			{
				slug: 'sku_stk',
				name: 'SKU STK',
				class: 'item-big',
				canSearch: true,
				canSort: true,
				sortType: 'string',
			},
			{
				slug: 'provider',
				name: 'Proveedor',
				class: 'item-medium',
				canSearch: true,
			},
			{
				slug: 'location_store',
				name: 'Almacen',
				class: 'item-medium',
			},
		];
		table.rows = [];
		for(let i = 0; i < pages.length; i++){
			table.rows.push(this.createRow(pages[i]));
		}
		return table;
	}

	createRow(page){
		return {
			item : page,
			brand : page.brand,
			sku : page.sku,
			name : page.name,
			sku_soultek : page.sku_soultek,
			sku_stk : page.sku_stk,
			provider : page.provider,
			location_store: page.location_store,
		};
	}

	
}





export default pageListProducts;




